import React from 'react';

function About({ resumeData }) {
  if (!resumeData) {
    return null;
  }

  return (
    <section id="about">
      <div className="row">
        <div className="twelve columns main-col">
          <h2>About Me</h2>
          <p>{resumeData.aboutme}</p>
          <div className="row">
            <div className="columns contact-details">
              <h2>Contact Details</h2>
              <p className="address">
                <span>{resumeData.name}</span>
                <br />
                {resumeData.address && <span>{resumeData.address}</span>}
                {resumeData.email && (
                  <>
                    <br />
                    <span>
                      <a href={`mailto:${resumeData.email}`}>{resumeData.email}</a>
                    </span>
                  </>
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;